import { useEffect, useState } from 'react';
import { useSettings } from '../contexts/SettingsContext';
import {
  UI_SURFACE_MD_BREAKPOINT,
  resolveUiSurfaceVisible,
} from '../utils/uiSurfaceVisibility';

/** Viewport « mobile » aligné sur le breakpoint Tailwind `md` (768px). */
export function useIsMobileSurface() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(max-width: ${UI_SURFACE_MD_BREAKPOINT - 1}px)`).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${UI_SURFACE_MD_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  return isMobile;
}

/** Afficher un élément d’UI selon la config web/mobile (Paramètres). */
export function useUiSurfaceVisible(surfaceId) {
  const { settings } = useSettings();
  const isMobile = useIsMobileSurface();
  return resolveUiSurfaceVisible(surfaceId, settings, isMobile);
}
